import React from 'react';
import api from 'app/entity/blog/blogApi';
import first from 'lodash/first';
import BlogLayout from 'app/components/blog/BlogLayout';
import Page from 'app/components/misc/BasePage/Blog';
import BlogSubHeader from 'app/components/blog/BlogSubHeader';
import {
  Article,
  MainContent,
  Body,
} from 'app/components/blog/article/ArticleDetail/styles';

const SubmitArticle = ({ page }) => {
  return (
    <Page renderSubHeader={() => <BlogSubHeader />}>
      <BlogLayout>
        <Article>
          <MainContent>
            <Body
              page
              dangerouslySetInnerHTML={{
                __html: page.content.rendered,
              }}
            />
          </MainContent>
        </Article>
      </BlogLayout>
    </Page>
  );
};

SubmitArticle.getInitialProps = async ({ res }) => {
  const response = await api.getSubmitArticlePage();
  if (response.ok) {
    return {
      page: first(response.data),
    };
  }

  res.statusCode = response.status;
  return {};
};

export default SubmitArticle;
